import React from 'react';
import LoginForm from '../../components/Login/LoginForm';
import AuthenticationLayout from '../../components/AuthenticationLayout/AuthenticationLayout';
import routeConstant from '../../lib/constants/routeConstant';
import middleImage from '../../assets/svgs/atlanta_logo.svg';

/*  Options object to determine the visibility and properties of the navigation button in the authentication layout. */
const options = {
  showButton: true,
  navUrl: routeConstant.SIGNUP_PAGE,
  buttonName: "Sign Up",
  heading: "Login",
  middleImage: middleImage,
  showMiddleImage: true
}

const LoginPage = () => {
  return (
    /* Render the AuthenticationLayout component as a wrapper around the CreatePasswordForm. Pass the options object 
     to control the layout's property */
    <AuthenticationLayout options={options}>
      <LoginForm />
    </AuthenticationLayout>
  )
}

export default LoginPage